<template>
    <v-text-field
        v-bind="$attrs"
        v-on="$listeners"
        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
        :type="showPassword ? 'text': 'password'"
        @click:append="showPassword = !showPassword"/>
</template>

<script>
export default {
    name: 'PasswordField',

    data () {
        return {
            showPassword: false
        }
    }
}
</script>

<style lang="scss" scoped></style>
